import store from '@/store'
import domain from '@/util/domain.js';
// Recuperando o id do usuário;
const crm_id = () => {
  if (store.state.logged.status) {
    return store.state.logged.data.id_usuario;
  } else {
    return '';
  }
}

// Recuperando o Nome do Operador;
const affiliation = store.state.operators.operator_name;

// Arredondamento de dizimas
const RoundHalfDown = function (num) {
  return -(Math.round(-num + "e+2") + "e-2");
}

// Tratamento de Odds no Cupom
const handlerOddsArray = (valueBet, odds) => {
  if (odds.length < 0) {
    return [];
  }
  var items = odds.map((item) => {
    // Regra de três para distribuir o valor o valor da aposta pelos items (odds).    
    var value_odd = item.data.odd_price;
    const array_odds = odds.map(item2 => Number(item2.data.odd_price));
    const initialValue = 0;
    const sum_odds_total = array_odds.reduce((previousValue, currentValue) => previousValue + currentValue, initialValue);
    var value_item = valueBet * value_odd / sum_odds_total;

    return {
      item_id: item.id_event, // id_event (para casar com "view_item")
      item_name: item.description, // time x time      
      brand: item.description, //                       
      quantity: 1,
      price: RoundHalfDown(value_item),
      currency: "BRL",
    }
  });
  return items;
}

// Integration SportRadar ADS;
// const sportradar = [''];

export default {
  install(Vue) {
    Vue.prototype.$gtag = {

      // ======================================================== //
      // 
      // EVENTOS RECOMENDADOS:
      // https://developers.google.com/tag-platform/devguides/events#google_analytics_4_events
      // 
      // ======================================================== //

      // 
      // Event "login"
      // https://developers.google.com/gtagjs/reference/event#login
      // 
      login: () => {
        gtag("event", "login", {
          method: "main_login",
          affiliation,
          crm_id: crm_id(),
        });

        // SportRadar ADS
        // if (sportradar.includes(domain())) {
        //   srtmCommands.push({
        //     event: "track.user.login",
        //     payload: {
        //       action: "complete",
        //       userId: crm_id(),
        //     },
        //   });
        // }
      },

      //
      // Event "sign_up"
      // https://developers.google.com/gtagjs/reference/event#sign_up
      // 
      sign_up: (method, data) => {
        gtag("event", "sign_up", {
          method: method,
          affiliation,
          crm_id: data.id_user,
          name: data.nome,
          email: data.email,
          phone: data.celular,
        });

        // SportRadar ADS
        // if (sportradar.includes(domain())) {
        //   srtmCommands.push({
        //     event: "track.user.registration",
        //     payload: {
        //       action: "complete",
        //       userId: data.id_user
        //     },
        //   });
        // }
      },

      //
      // Event "pre_sign_up" (Personalizado!)      
      // 
      pre_sign_up: (method, id_user, data) => {
        gtag("event", "pre_sign_up",
          {
            method: method,
            affiliation,
            crm_id: id_user,
            name: data.nome,
            email: data.email,
            phone: data.celular,
          });
      },

      // 
      // handler "purchase" bet types
      // 
      handler_purchase: (bet, odds_selecteds, resp, url) => {

        // Logs
        // console.log('handler_purchase');
        // console.log("bet ", bet);
        // console.log("odds_selecteds ", odds_selecteds);
        // console.log("resp ", resp);
        // console.log("url ", url);

        // Tratando os Items:
        var items = handlerOddsArray(bet.value_bet, odds_selecteds);

        // Parâmetros        
        const data = {
          affiliation, // OPERATOR
          coupon: resp.bonus_status == "1" ? "BONUS" : "",
          currency: "BRL",
          shipping: 0, // frete
          tax: 0, // impostos e taxas
          transaction_id: resp.id_bet, // id da aposta
          value: Number(bet.value_bet), // valor da aposta
          crm_id: crm_id(),
          items: items,
        }

        if (url == "/player/online/betsOnline/placebet") {
          Vue.prototype.$gtag.purchase(data);
        } else {
          Vue.prototype.$gtag.bet(data, url);
        }
      },

      //
      // Event "purchase"
      // https://developers.google.com/gtagjs/reference/event#purchase
      // 
      purchase: (data) => {
        // console.log('purchase');
        // console.log(data);
        gtag("event", "purchase", data);
      },

      //
      // Search
      // https://developers.google.com/gtagjs/reference/event#search
      // 
      search: (term) => {
        // console.log(term);
        gtag("event", "search", { search_term: term, affiliation, });
      },

      // 
      // View cupom/bilhete (Apenas Mobile)
      // https://developers.google.com/gtagjs/reference/event#view_cart
      // 
      view_cart: (value) => {
        var odds = store.state.coupons;
        var items = handlerOddsArray(value, odds);
        gtag("event", "view_cart", {
          currency: "BRL",
          value: value,
          affiliation,
          items: items
        });
      },

      // Select Item Cassino
      select_item_casino: (event) => {
        // console.log('select_item');
        // console.log(event);
        const { item_list_id, item_list_name, item_id, item_name, item_category } = event;
        var dataEvent = {
          item_list_id: `${item_list_id}`, // Id do Torneio
          item_list_name, // Nome do Torneio
          affiliation,
          items: [
            {
              item_id: `${item_id}`,
              item_name,
              affiliation,
              item_brand: "Pragmatic Play",
              item_category,
              item_list_id: `${item_list_id}`,
              item_list_name,
              index: 1,
              quantity: 1
            }
          ]
        };
        // console.log('select_item_casino');
        // console.log(dataEvent);
        gtag("event", "select_item", dataEvent);
      },

      //
      // view_item_list
      // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br
      // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br#view_item_list
      view_item_list_casino: (event) => {
        // console.log(event);
        const { item_list_id, item_list_name, item_category, item_id, item_name } = event;
        const dataEvent = {
          item_list_id: `${item_list_id}`,
          item_list_name,
          affiliation,
          items: [{
            item_id: `${item_id}`,
            item_name: item_name,
            item_list_id,
            item_list_name,
            affiliation,
            item_brand: 'Pragmatic Play',
            item_category,
            index: 1,
            quantity: 1
          }]
        }
        // console.log('view_item_list_casino');
        // console.log(dataEvent);
        gtag('event', 'view_item_list', dataEvent);
      },

      //
      // view_item_list
      // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br
      // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br#view_item_list
      view_item_list: (event) => {
        // console.log(event);
        const { id_sport, item_list_id, item_list_name, item_id, item_name, item_category, item_category2 } = event;
        var item_brand = store.getters.getNameSportById(`${id_sport}`);
        const dataEvent = {
          item_list_id: `${item_list_id}`, // Id do: País ou Torneio
          item_list_name, // Nome do: País ou Torneio
          affiliation,
          items: [{
            item_id: `${item_id}`,  // Id do: País ou Torneio (repete *)
            item_name: item_name, // Nome do: País ou Torneio (repete *)
            item_list_id,  // Id do: País ou Torneio (repete *)
            item_list_name, // Nome do: País ou Torneio (repete *)
            affiliation, // Name Operator
            item_brand, // Esporte, ex: FUTEBOL
            item_category, // Esporte: FUTEBOL
            item_category2, // live or pre-match 
            index: 1,
            quantity: 1
          }]
        }
        // Teoricamente, essa lista de itens deveria conter a lista de eventos.
        // console.log(dataEvent);
        gtag('event', 'view_item_list', dataEvent);
      },

      //
      // View Item
      // Quando o usuáro abre um Evento
      // https://developers.google.com/gtagjs/reference/event#view_item
      // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br#view_item
      // 
      view_item: (event, category, tournament) => {
        // console.log(event);
        // console.log(tournament);        

        var nameSport = store.getters.getNameSportById(event.id_sport);
        var live = event.live == '1' ? 'live' : 'pre-match';

        gtag("event", "view_item", {
          currency: 'BRL',
          value: 0,
          affiliation,
          items: [{
            item_id: `${event.id_match}`, // Id do encontro
            item_name: event.description,
            item_brand: event.description, // Evento
            item_category: nameSport, // e.g. "Futebol"
            item_category2: category, // País
            item_category3: tournament, // Campeonato           
            item_category4: live, // live or pre-match           
            list_name: tournament, // Campeonato               
            affiliation,
            quantity: 1,
            item_variant: event.scheduled // "Black"
          }]
        });
      },

      //
      // select_item
      // Quando o usuário interagir com um evento (abertura de evento a partir de uma lista)
      // Exemplo
      // Após a pesquisa, um usuário clica no link de um produto.
      // Não confunda esse evento com view_item.
      // https://developers.google.com/gtagjs/reference/ga4-events?hl=pt-br#select_item
      // https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br#select_item
      // 
      select_item: (event) => {
        // console.log('select_item');
        // console.log(event);
        const { id_sport, item_list_id, item_list_name, item_id, item_name, item_category, item_category2, item_category3, item_category4 } = event;
        var item_brand = store.getters.getNameSportById(`${id_sport}`);
        var dataEvent = {
          item_list_id: `${item_list_id}`, // Id do Torneio
          item_list_name, // Nome do Torneio
          affiliation,
          items: [
            {
              item_id: `${item_id}`, // Id do Evento
              item_name, // Time x Time
              affiliation, // nome do operator
              item_brand, // Esporte "FUTEBOL"
              item_category, // Esporte ex: FUTEBOL
              item_category2, // País
              item_category3, // Torneio
              item_category4, // live or pre-match 
              item_list_id: `${item_list_id}`, // torneio id
              item_list_name, // torneio name
              index: 1,
              quantity: 1
            }
          ]
        };
        // console.log('dataEvent');
        // console.log(dataEvent);
        gtag("event", "select_item", dataEvent);
      },

      // 
      // add_to_cart
      // https://developers.google.com/gtagjs/reference/ga4-events#add_to_cart
      // 
      add_to_cart: (odd) => {
        gtag("event", "add_to_cart", {
          currency: "BRL",
          value: 0,
          affiliation,
          items: [
            {
              item_id: odd.id_event,
              item_name: odd.description,
              affiliation,
              location_id: odd.id_odd,
              quantity: 1
            }
          ]
        });
      },

      // 
      // remove_from_cart
      // https://developers.google.com/gtagjs/reference/ga4-events#remove_from_cart
      // 
      remove_from_cart: (odd) => {
        gtag("event", "remove_from_cart", {
          currency: "BRL",
          value: 0,
          affiliation,
          items: [
            {
              item_id: odd.id_event,
              item_name: odd.description,
              affiliation,
              location_id: odd.id_odd,
              quantity: 1
            }
          ]
        });
      },

      // 
      // add_payment_info
      // https://developers.google.com/gtagjs/reference/ga4-events#add_payment_info
      // 
      add_payment_info: (info) => {
        gtag("event", "add_payment_info", {
          currency: "BRL",
          value: 0,
          payment_type: "PIX",
          affiliation,
          items: [
            {
              item_id: info.key, // Chave PIX
              item_name: info.type, // Tipo (cpf, email, tel, aleatória)
              affiliation,
            }
          ]
        });
      },

      // 
      // add_shipping_info
      // https://developers.google.com/gtagjs/reference/ga4-events#add_shipping_info
      // 
      add_shipping_info: (info) => {
        gtag("event", "add_shipping_info", {
          currency: "BRL",
          value: 0,
          shipping_tier: 'address',
          affiliation,
          items: [
            {
              item_id: info.id_estado,
              item_name: info.estado,
              affiliation,
              item_category: info.endereco,
              item_category2: info.bairro,
              item_category3: info.id_municipio,
              item_category4: info.cep,
            }
          ]
        });
      },

      // 
      // select_content
      // https://developers.google.com/gtagjs/reference/ga4-events#select_content
      //
      select_content: (value, id) => {
        gtag("event", "select_content", {
          content_type: value,
          item_id: id,
          affiliation,
        });
      },

      // 
      // earn_virtual_currency
      // https://developers.google.com/gtagjs/reference/ga4-events#earn_virtual_currency
      //
      earn_virtual_currency: (type, value) => {
        gtag("event", "earn_virtual_currency", {
          virtual_currency_name: type,
          value: Number(value),
          affiliation,
        });
      },

      // 
      // spend_virtual_currency
      // https://developers.google.com/gtagjs/reference/ga4-events#spend_virtual_currency
      //
      spend_virtual_currency: (type, value, item_name) => {
        gtag("event", "spend_virtual_currency", {
          virtual_currency_name: type,
          value: value,
          item_name: item_name,
          affiliation,
        });
      },

      // 
      // share
      // https://developers.google.com/gtagjs/reference/ga4-events#share
      //
      share: (method, content_type, item_id) => {
        gtag("event", "share", {
          method: method,
          content_type: content_type,
          item_id: item_id,
          affiliation,
        });
      },

      // 
      // add_to_wishlist
      // https://developers.google.com/gtagjs/reference/ga4-events#add_to_wishlist
      // 
      add_to_wishlist: (item_id, item_name) => {
        gtag("event", "add_to_wishlist", {
          currency: "BRL",
          value: 0,
          items: [
            {
              item_id: item_id,
              item_name: item_name,
              affiliation,
              quantity: 1
            }
          ],
        });
      },

      // ======================================================== //
      // 
      // EVENTOS PERSONALIZADOS:
      // https://developers.google.com/tag-platform/devguides/events#google_analytics_4_events
      // 
      // ======================================================== //

      // 
      //  first_deposit 
      first_deposit: (value, isBonus) => {
        gtag("event", "first_deposit", {
          currency: 'BRL',
          value: Number(value),
          type_deposit: isBonus == true ? "DepositBonus" : "Deposit",
          affiliation,
          crm_id: crm_id(),
        })

        // SportRadar ADS
        // if (sportradar.includes(domain())) {
        //   srtmCommands.push({
        //     event: "track.betting.deposit",
        //     payload: {
        //       action: "created",
        //       label: "first_deposit",
        //       userId: crm_id(),
        //       transactionId: "",
        //       amount: value,
        //       currency: "BRL",
        //     }
        //   });
        // }
      },

      //
      // start registration
      start_registration: (nameOrCPF) => {
        gtag("event", "start_registration", {
          affiliation,
          nameOrCPF,
        });

        // SportRadar ADS
        // if (sportradar.includes(domain())) {
        //   srtmCommands.push({
        //     event: "track.user.registration",
        //     payload: { action: "start" },
        //   });
        // }
      },

      // 
      // Pix Gerado
      generate_pix: (value, isBonus) => {
        gtag("event", "generate_pix", {
          currency: 'BRL',
          value: Number(value),
          type_deposit: isBonus == true ? "DepositBonus" : "Deposit",
          affiliation,
          crm_id: crm_id(),
        })
      },

      // 
      // Pix Consolidado
      consolidated_pix: (value, isBonus) => {
        gtag("event", "consolidated_pix", {
          currency: 'BRL',
          value: Number(value),
          type_deposit: isBonus ? "DepositBonus" : "Deposit",
          affiliation,
          crm_id: crm_id(),
        });

        // SportRadar ADS
        // if (sportradar.includes(domain())) {
        //   srtmCommands.push({
        //     event: "track.betting.deposit",
        //     payload: {
        //       action: "created",
        //       userId: crm_id(),
        //       transactionId: "",
        //       amount: value,
        //       currency: "BRL",
        //     },
        //   });
        // }

      },

      //
      // generate_saque
      generate_saque: (value) => {
        gtag("event", "generate_saque", {
          currency: 'BRL',
          value: Number(value),
          affiliation,
          crm_id: crm_id(),
        })
      },

      // 
      // Event "bet" 
      bet: (data, url) => {

        // console.log(data);
        // console.log(url);

        // Encaminhando para o registro 
        switch (url) {
          case "/player/bonus/betsOnline/placebet":
            gtag("event", "purchase_bet_player_bonus", data);
            // register spend_virtual_currency event;
            data.items.forEach(item => {
              Vue.prototype.$gtag.spend_virtual_currency('BONUS', item.price, item.item_name);
            });
            break;
          case "/player/bets/betAnonymous":
            gtag("event", "purchase_bet_anonymous", data);
            break;
          case "/player/bets/betAnonymousNoSms":
            gtag("event", "purchase_bet_anonymous_no_sms", data);
            break;
          case "/player/bets/preBet":
            gtag("event", "purchase_bet_player_pre_bet", data);
            break;
          case "/player/bets/placebet":
            gtag("event", "purchase_bet_player_placebet", data);
            break;
          // Agent
          case "/agent/retail/bets/placeBet": // retail = 1
            gtag("event", "purchase_bet_ag_retail_placebet", data);
            break;
          case "/agent/bets/placeBet":
            gtag("event", "purchase_bet_ag_placebet", data);
            break;
          default:
            break;
        }
      },

    }
  }
}